export var ACTION;
(function (ACTION) {
    ACTION["INIT"] = "INIT";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
    ACTION["SUCCESS_VERIFICATION"] = "SUCCESS_VERIFICATION";
    ACTION["CHANGE_BANK_ACCOUNT"] = "CHANGE_BANK_ACCOUNT";
    ACTION["RESET_ERROR_MODAL"] = "RESET_ERROR_MODAL";
    ACTION["INIT_TATA_MANDATE"] = "INIT_TATA_MANDATE";
    ACTION["MANDATE_CALLBACK"] = "MANDATE_CALLBACK";
    ACTION["CONTACT_US_CARD"] = "CONTACT_US_CARD";
    ACTION["CHANGE"] = "CHANGE";
    ACTION["RETRY"] = "RETRY";
    ACTION["CONTACT_US"] = "CONTACT_US";
})(ACTION || (ACTION = {}));
